export const eventEmitter = () => {
    const listeners = {};
    return {
        _listeners: listeners,
        on(eventName, fn) {
            listeners[eventName] = (listeners[eventName] || []).concat(fn);
        },
        off(eventName, fn) {
            listeners[eventName] = (listeners[eventName] || []).filter((f) => f !== fn);
        },
        emit(eventName, ...params) {
            (listeners[eventName] || []).forEach((fn) => params[0] ? fn(params[0]) : fn());
        },
    };
};
//# sourceMappingURL=EventEmitter.js.map